/* Nimbus localization: display-currency converter + auto currency (IP) + auto language (browser).
   Base currency EUR. Prices convert client-side; checkout stays EUR (display only). */
(function () {
  'use strict';

  /* Never auto-redirect / auto-switch inside the theme editor or a theme preview. */
  function isEditorOrPreview(){
    try {
      if (window.Shopify && window.Shopify.designMode) return true;
      if (/[?&](preview_theme_id|_ab|_fd|_sc|_pos|_currency)=/.test(location.search)) return true;
    } catch(e){}
    return false;
  }

  /* code -> [flag ISO country, display name]. Rates limit which ones actually show. */
  var CURRENCIES = {
    EUR:['eu','Euro'], USD:['us','US Dollar'], GBP:['gb','British Pound'], JPY:['jp','Japanese Yen'],
    AUD:['au','Australian Dollar'], CAD:['ca','Canadian Dollar'], CHF:['ch','Swiss Franc'],
    CNY:['cn','Chinese Yuan'], HKD:['hk','Hong Kong Dollar'], NZD:['nz','New Zealand Dollar'],
    SEK:['se','Swedish Krona'], NOK:['no','Norwegian Krone'], DKK:['dk','Danish Krone'],
    PLN:['pl','Polish Złoty'], CZK:['cz','Czech Koruna'], HUF:['hu','Hungarian Forint'],
    RON:['ro','Romanian Leu'], BGN:['bg','Bulgarian Lev'], TRY:['tr','Turkish Lira'],
    RUB:['ru','Russian Ruble'], UAH:['ua','Ukrainian Hryvnia'], ISK:['is','Icelandic Króna'],
    AED:['ae','UAE Dirham'], SAR:['sa','Saudi Riyal'], QAR:['qa','Qatari Riyal'], KWD:['kw','Kuwaiti Dinar'],
    BHD:['bh','Bahraini Dinar'], OMR:['om','Omani Rial'], ILS:['il','Israeli Shekel'], JOD:['jo','Jordanian Dinar'],
    EGP:['eg','Egyptian Pound'], MAD:['ma','Moroccan Dirham'], ZAR:['za','South African Rand'],
    NGN:['ng','Nigerian Naira'], KES:['ke','Kenyan Shilling'], GHS:['gh','Ghanaian Cedi'],
    INR:['in','Indian Rupee'], PKR:['pk','Pakistani Rupee'], BDT:['bd','Bangladeshi Taka'], LKR:['lk','Sri Lankan Rupee'],
    SGD:['sg','Singapore Dollar'], MYR:['my','Malaysian Ringgit'], THB:['th','Thai Baht'], IDR:['id','Indonesian Rupiah'],
    PHP:['ph','Philippine Peso'], VND:['vn','Vietnamese Dong'], KRW:['kr','South Korean Won'], TWD:['tw','Taiwan Dollar'],
    MXN:['mx','Mexican Peso'], BRL:['br','Brazilian Real'], ARS:['ar','Argentine Peso'], CLP:['cl','Chilean Peso'],
    COP:['co','Colombian Peso'], PEN:['pe','Peruvian Sol'], UYU:['uy','Uruguayan Peso'], DOP:['do','Dominican Peso'],
    CRC:['cr','Costa Rican Colón'], GTQ:['gt','Guatemalan Quetzal'], BOB:['bo','Bolivian Boliviano'],
    HRK:['hr','Croatian Kuna'], RSD:['rs','Serbian Dinar'], MKD:['mk','Macedonian Denar'], ALL:['al','Albanian Lek'],
    GEL:['ge','Georgian Lari'], AZN:['az','Azerbaijani Manat'], KZT:['kz','Kazakhstani Tenge'],
    DZD:['dz','Algerian Dinar'], TND:['tn','Tunisian Dinar'], LBP:['lb','Lebanese Pound'],
    NAD:['na','Namibian Dollar'], MUR:['mu','Mauritian Rupee'], XOF:['sn','West African Franc'], XAF:['cm','Central African Franc'],
    FJD:['fj','Fijian Dollar'], NPR:['np','Nepalese Rupee'], MMK:['mm','Myanmar Kyat'], KHR:['kh','Cambodian Riel'],
    MDL:['md','Moldovan Leu'], BAM:['ba','Bosnian Mark'], PYG:['py','Paraguayan Guaraní'], HNL:['hn','Honduran Lempira'],
    JMD:['jm','Jamaican Dollar'], TTD:['tt','Trinidad Dollar'], BWP:['bw','Botswana Pula'], UGX:['ug','Ugandan Shilling'],
    TZS:['tz','Tanzanian Shilling'], XCD:['ag','East Caribbean Dollar'], BSD:['bs','Bahamian Dollar'],
    MNT:['mn','Mongolian Tögrög'], UZS:['uz','Uzbekistani Som'], IQD:['iq','Iraqi Dinar']
  };
  /* country (ISO alpha-2) -> currency, for IP-based auto currency */
  var COUNTRY_CUR = {
    US:'USD', GB:'GBP', IE:'EUR', DE:'EUR', FR:'EUR', ES:'EUR', IT:'EUR', NL:'EUR', BE:'EUR', AT:'EUR', PT:'EUR', FI:'EUR', GR:'EUR', LU:'EUR', SK:'EUR', SI:'EUR', EE:'EUR', LV:'EUR', LT:'EUR', CY:'EUR', MT:'EUR', HR:'EUR',
    CH:'CHF', LI:'CHF', SE:'SEK', NO:'NOK', DK:'DKK', IS:'ISK',
    PL:'PLN', CZ:'CZK', HU:'HUF', RO:'RON', BG:'BGN', UA:'UAH', RU:'RUB', TR:'TRY', RS:'RSD', BA:'BAM', MK:'MKD', AL:'ALL', MD:'MDL', GE:'GEL', AZ:'AZN', KZ:'KZT',
    CA:'CAD', MX:'MXN', BR:'BRL', AR:'ARS', CL:'CLP', CO:'COP', PE:'PEN', UY:'UYU', DO:'DOP', CR:'CRC', GT:'GTQ', BO:'BOB', PY:'PYG', HN:'HNL', JM:'JMD', TT:'TTD', BS:'BSD',
    AU:'AUD', NZ:'NZD', FJ:'FJD',
    JP:'JPY', CN:'CNY', HK:'HKD', TW:'TWD', KR:'KRW', SG:'SGD', MY:'MYR', TH:'THB', ID:'IDR', PH:'PHP', VN:'VND', IN:'INR', PK:'PKR', BD:'BDT', LK:'LKR', NP:'NPR', MM:'MMK', KH:'KHR', MN:'MNT', UZ:'UZS',
    AE:'AED', SA:'SAR', QA:'QAR', KW:'KWD', BH:'BHD', OM:'OMR', IL:'ILS', JO:'JOD', LB:'LBP', IQ:'IQD', EG:'EGP', MA:'MAD', DZ:'DZD', TN:'TND',
    ZA:'ZAR', NG:'NGN', KE:'KES', GH:'GHS', NA:'NAD', MU:'MUR', BW:'BWP', UG:'UGX', TZ:'TZS', SN:'XOF', CM:'XAF',
    AG:'XCD', DM:'XCD', GD:'XCD', KN:'XCD', LC:'XCD', VC:'XCD'
  };
  var FALLBACK = { EUR:1, USD:1.08, GBP:0.85, JPY:169, AUD:1.64, CAD:1.47, CHF:0.94, SEK:11.3, NOK:11.6,
                   DKK:7.46, PLN:4.30, NZD:1.78, SGD:1.45, AED:3.97, USD_PEG:1 };

  var KEY='sb_currency', RKEY='sb_rates_v2', AUTOK='sb_geo_done';
  var rates = FALLBACK;
  var ratesLoaded = false;

  /* `current` is de valuta die NU op het scherm staat, `wanted` die de bezoeker
     gekozen heeft. Zolang er geen koers voor `wanted` is blijft alles in EUR:
     een bedrag tonen onder een ander valutateken zonder om te rekenen zou een
     verkeerde prijs zijn. */
  var stored='';
  try { stored = localStorage.getItem(KEY) || ''; } catch(e){}
  var userChose = !!stored && !!CURRENCIES[stored];
  var wanted = userChose ? stored : 'EUR';
  var current = 'EUR';

  var SELECTOR='[data-eur], .sb-money, .etrans-money';

  function cookie(name){ var m=document.cookie.match('(?:^|; )'+name+'=([^;]*)'); return m?decodeURIComponent(m[1]):null; }
  function setCookie(name,val,days){ var d=new Date(Date.now()+(days||365)*864e5); document.cookie=name+'='+encodeURIComponent(val)+'; expires='+d.toUTCString()+'; path=/; SameSite=Lax'; }

  /* ── Rates (open.er-api.com, EUR base, ~160 currencies) ── */
  function loadRates(){
    if(ratesLoaded) return Promise.resolve();
    try { var c=JSON.parse(localStorage.getItem(RKEY)||'null'); if(c&&c.r&&(Date.now()-c.t)<6*36e5){ rates=c.r; ratesLoaded=true; return Promise.resolve(); } } catch(e){}
    return fetch('https://open.er-api.com/v6/latest/EUR')
      .then(function(r){return r.json();})
      .then(function(d){ if(d&&d.rates){ rates=d.rates; rates.EUR=1; ratesLoaded=true; try{localStorage.setItem(RKEY,JSON.stringify({t:Date.now(),r:rates}));}catch(e){} } })
      .catch(function(){});
  }

  /* Koers voor een valuta, of null als we er geen hebben. Nooit stilzwijgend 1:
     dat zou de europrijs onder een vreemd valutateken tonen. */
  function rateFor(code){
    if(code==='EUR') return 1;
    var r = rates[code];
    if(r==null) r = FALLBACK[code];
    return (typeof r==='number' && isFinite(r) && r>0) ? r : null;
  }

  function parseEur(text){ var t=(text||'').replace(/[^\d.,]/g,''); if(!t)return NaN; if(t.indexOf(',')>-1){t=t.replace(/\./g,'').replace(',','.');} return parseFloat(t); }
  function fmt(a,code){ try{ return new Intl.NumberFormat('en',{style:'currency',currency:code,currencyDisplay:'narrowSymbol'}).format(a); } catch(e){ return code+' '+a.toFixed(2); } }

  function convertAll(){
    var rate = rateFor(current);
    if(rate==null) return;                  /* geen koers: prijzen ongemoeid in EUR laten */
    /* De stempel bevat ook de koers, zodat een prijs opnieuw wordt berekend
       wanneer er later een betere koers binnenkomt. */
    var stamp = current+':'+rate;
    var els=document.querySelectorAll(SELECTOR);
    for(var i=0;i<els.length;i++){ var el=els[i];
      if(el.dataset.baseEur==null){
        /* Bedragen die als eigen regel in een andere valuta vastliggen (zoals de
           Amerikaanse verzenddrempel in USD) geven die valuta mee; die rekenen we
           eerst terug naar een EUR-basis zodat er één rekenwijze blijft. */
        var amt=el.getAttribute('data-amount');
        var amtCur=(el.getAttribute('data-amount-cur')||'EUR').toUpperCase();
        var base;
        if(amt!=null){
          var amtRate=rateFor(amtCur);
          if(amtRate==null)continue;          /* koers onbekend: bedrag ongemoeid laten */
          base=parseFloat(amt)/amtRate;
        } else {
          var a=el.getAttribute('data-eur');
          base=a!=null?parseFloat(a):parseEur(el.textContent);
        }
        if(isNaN(base))continue;
        el.dataset.baseEur=base;
        el.dataset.baseCur=amtCur;
        el.dataset.origText=el.textContent;
      }
      if(el.dataset.stamp===stamp)continue;
      var b=parseFloat(el.dataset.baseEur);
      /* Staat de weergave in de eigen valuta van het bedrag, toon dan de originele
         tekst: op een harde regel als een verzenddrempel hoort geen afrondingsdrift. */
      el.textContent = (el.dataset.baseCur||'EUR')===current ? el.dataset.origText : fmt(b*rate, current);
      el.dataset.stamp=stamp;
      el.dataset.cur=current;
    }
  }

  function flagUrl(cc){ return '//cdn.shopify.com/static/images/flags/'+cc+'.svg?width=40'; }

  function updateTriggers(){
    var meta=CURRENCIES[current]||['eu',current];
    var sym; try{ sym=(0).toLocaleString('en',{style:'currency',currency:current,currencyDisplay:'narrowSymbol'}).replace(/[\d.,\s]/g,''); }catch(e){ sym=current; }
    document.querySelectorAll('[data-currency-current]').forEach(function(el){ el.textContent=current; });
    /* Valuta's zonder eigen teken (SAR, AED, CHF...) geven de code als "symbool"
       terug. Die dan niet nog een keer tonen: anders staat er "SAR SAR". */
    var symIsCode = !sym || sym.toUpperCase() === current.toUpperCase();
    document.querySelectorAll('[data-currency-symbol-out]').forEach(function(el){
      el.textContent = symIsCode ? '' : sym;
      el.hidden = symIsCode;
    });
    document.querySelectorAll('[data-currency-flag] img').forEach(function(img){ img.src=flagUrl(meta[0]); });
    document.querySelectorAll('[data-currency]').forEach(function(b){ b.classList.toggle('is-active', b.getAttribute('data-currency')===current); });
  }

  function setCurrency(code, byUser){
    if(!CURRENCIES[code]) return;
    wanted=code;
    if(byUser){ userChose=true; try{localStorage.setItem(KEY,code);}catch(e){} }

    if(rateFor(code)==null){
      /* Nog geen koers. Koersen ophalen en daarna alsnog omschakelen; lukt dat
         niet, dan blijft de winkel in EUR staan in plaats van een fout bedrag
         onder een ander valutateken te tonen. */
      if(!ratesLoaded){
        loadRates().then(function(){ buildList(); if(rateFor(code)!=null) setCurrency(code,false); });
      }
      return;
    }
    current=code;
    convertAll(); updateTriggers();
  }
  window.NimbusCurrency={ set:function(c){setCurrency(c,true);}, get:function(){return current;}, refresh:convertAll };

  /* ── Build the currency option list (only currencies we have a rate for) ── */
  function buildList(){
    var ul=document.querySelector('[data-currency-list]'); if(!ul)return;
    /* Alleen valuta tonen waarvoor we echt een koers hebben. */
    var codes=Object.keys(CURRENCIES).filter(function(c){ return rateFor(c)!=null; });
    /* Skip pointless rebuilds: only re-render when the number of available currencies changed */
    if(ul.__count===codes.length)return; ul.__count=codes.length;
    var html='';
    codes.forEach(function(c){ var m=CURRENCIES[c];
      html+='<li data-cur-item data-cur-search="'+(m[1]+' '+c).toLowerCase()+'"><button type="button" class="nimbus-locale__opt'+(c===current?' is-active':'')+'" data-currency="'+c+'">'
        +'<span class="nimbus-locale__flag"><img src="'+flagUrl(m[0])+'" width="40" height="30" alt="" loading="lazy"></span>'
        +'<span class="nimbus-locale__opt-name">'+m[1]+'</span>'
        +'<span class="nimbus-locale__opt-currency">'+c+'</span></button></li>';
    });
    ul.innerHTML=html;
  }

  /* search filter */
  document.addEventListener('input', function(e){
    var s=e.target; if(!s.matches||!s.matches('[data-currency-search]'))return;
    var q=s.value.trim().toLowerCase();
    document.querySelectorAll('[data-cur-item]').forEach(function(li){ li.hidden = q!=='' && li.getAttribute('data-cur-search').indexOf(q)===-1; });
  });

  /* click a currency */
  document.addEventListener('click', function(e){
    var btn=e.target.closest&&e.target.closest('[data-currency]'); if(!btn)return;
    e.preventDefault(); setCurrency(btn.getAttribute('data-currency'), true);
    var det=btn.closest('details[open]'); if(det)det.removeAttribute('open');
  });

  /* ── Auto currency by IP (first visit, only if user hasn't chosen) ── */
  function autoCurrency(){
    if(isEditorOrPreview()) return Promise.resolve();
    if(userChose) return Promise.resolve();
    if(cookie(AUTOK)) return Promise.resolve();
    return fetch('https://ipwho.is/?fields=success,country_code').then(function(r){return r.json();})
      .then(function(d){ setCookie(AUTOK,'1',365);
        var cc=d&&d.country_code;
        var code=cc&&COUNTRY_CUR[cc];
        if(code&&CURRENCIES[code]&&!userChose){ setCurrency(code,false); }
      }).catch(function(){ setCookie(AUTOK,'1',7); });
  }

  /* ── Auto language by browser (first visit) ── */
  function autoLanguage(){
    try {
      if(isEditorOrPreview()) return;
      if(cookie('sb_lang_done')) return;
      var data=window.__nimbusLocales; if(!data||!data.list||data.list.length<2) return;
      setCookie('sb_lang_done','1',365);
      var want=(navigator.language||'en').slice(0,2).toLowerCase();
      var match=null;
      data.list.forEach(function(l){ if(l.iso.slice(0,2).toLowerCase()===want) match=l; });
      if(!match) return;                       /* not available -> stay (English default) */
      if(match.iso===data.current) return;     /* already on it */
      /* build localized path preserving the current page */
      var path=location.pathname;
      if(data.currentRoot && data.currentRoot!=='/' && path.indexOf(data.currentRoot)===0){ path=path.slice(data.currentRoot.length)||'/'; }
      var prefix=(match.root && match.root!=='/')?match.root:'';
      var target=prefix + (path.charAt(0)==='/'?path:'/'+path) + location.search + location.hash;
      if(target!==location.pathname+location.search+location.hash) location.replace(target);
    } catch(e){}
  }

  var pending=null;
  var mo=new MutationObserver(function(){ if(pending)return; pending=requestAnimationFrame(function(){pending=null;convertAll();}); });

  function boot(){
    autoLanguage();                 /* may redirect before anything else */
    buildList(); updateTriggers(); convertAll();
    loadRates().then(function(){
      buildList();
      /* Pas nu de gekozen valuta toepassen: daarvoor was er nog geen koers. */
      if(wanted!=='EUR') setCurrency(wanted,false);
      convertAll();
      return autoCurrency();
    });
    if(document.body) mo.observe(document.body,{childList:true,subtree:true,characterData:true});
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
})();
